const Language =  {
    FRENCH: 1,
    GERMAN: 2,
    ENGLISH: 3
};

export default Language;